import { z } from "zod"

const MAX_FILE_SIZE = 5000000
export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
]

export const postSchema = z.object({
  title: z.string().min(5),
  describtion: z.string().min(0),
  picture: z
    .any()
    .refine((files) => files?.length == 1, "Image is required.")
    .refine(
      (files) => files?.[0]?.size <= MAX_FILE_SIZE,
      `Max file size is 5MB.`,
    )
    .refine(
      (files) => ACCEPTED_IMAGE_TYPES.includes(files?.[0]?.type),
      ".jpg, .jpeg, .png and .webp files are accepted.",
    ),
  /*password: z.string().min(10, 'Password must be at least 10 characters'),
    confirmPassword: z.string(),*/
})

export const projectSchema = z.object({
  name: z.string().min(3, "Name must be at least 3 characters"),
  description: z.string().min(10, "Description must be at least 10 characters"),
  cover: z.string().url("Must be a valid URL").or(z.any()), // Simplified for now
  link: z.string().url("Must be a valid URL").optional().or(z.literal("")),
  demoLink: z.string().url("Must be a valid URL").optional().or(z.literal("")),
  category: z.string().optional(),
  role: z.string().optional(),
  skills: z.array(z.string()).optional(),
  publishedAt: z.string().optional(),
  videoUrl: z.string().url("Must be a valid URL").optional().or(z.literal("")),
  projectType: z.enum(["Frontend", "Backend", "Full Stack"]).optional(),
  assets: z.array(z.object({
    type: z.enum(["image", "video"]),
    url: z.string().url("Must be a valid URL")
  })).optional(),
  slug: z.string().min(3).optional(),
})

export const skillSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  type: z.enum(["Frontend", "Backend", "Other"]),
  imageUrl: z.string().url("Must be a valid URL").or(z.any()),
})

export type TskillSchema = z.infer<typeof skillSchema>
export type TprojectSchema = z.infer<typeof projectSchema>
/*.refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  })*/

export type TpostSchema = z.infer<typeof postSchema>

// Project type used across the app
export type Project = {
  id: string
  name: string
  description: string
  cover: string
  link?: string
  demoLink?: string
  category?: string
  iconUrl?: string
  theme?: string
  role?: string
  skills?: string[]
  publishedAt?: string
  videoUrl?: string
  projectType?: "Frontend" | "Backend" | "Full Stack"
  assets?: { type: "image" | "video"; url: string }[]
  slug: string
}

// Post type
export type Post = {
  id: string
  title: string
  description: string
  picture: string
  category?: string
  createdAt: string
}

// Skill type
export type Skill = {
  id: string
  name: string
  type: "Frontend" | "Backend" | "Other"
  imageUrl: string
}
